<div class="user-name">
  {{ user.data.name }} {{ user.isSelf ? ('(You)' | translate) : '' }}
</div>
